import { useEffect } from "react";

// The mobile browser chrome (iOS Safari's toolbar, Android's status + nav bars)
// tints itself from <meta name="theme-color">. Without it those strips default to
// white and don't match the page — jarring on the dark-warm full-screen Stage,
// where the browser bars framed the viewer in white (Leon, #ui-polish). This keeps
// the meta in sync with the active surface so the bars read as part of the page.
//
// The tag ships in index.html (paper, for first paint on the light routes); this
// hook flips it to the Stage's own background on the immersive viewer/upload routes
// and restores paper on the light pages.
export const THEME_COLOR = {
  // The Soft White page canvas (--color-paper) used by the landing + normal pages.
  paper: "#fafafa",
  // The dark-warm Stage background (DEFAULT_STAGE_CONFIG.backgroundColor) behind the
  // full-screen viewer — so the top status bar + bottom nav bar blend into the sweep.
  stage: "#3a2109",
} as const;

export function useThemeColor(color: string): void {
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta) return;
    const previous = meta.content;
    meta.content = color;
    return () => {
      meta.content = previous;
    };
  }, [color]);
}
